var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaster(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.0765 5.1499H13.2166C8.79827 5.1499 5.21655 8.73162 5.21655 13.1499V55.01C5.21655 59.4283 8.79827 63.01 13.2166 63.01H55.0765C59.4948 63.01 63.0765 59.4283 63.0765 55.01V13.1499C63.0765 8.73162 59.4948 5.1499 55.0765 5.1499Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9268 0.0100098H8.06665C3.64837 0.0100098 0.0666504 3.59173 0.0666504 8.01001V49.8701C0.0666504 54.2884 3.64837 57.8701 8.06665 57.8701H49.9268C54.345 57.8701 57.9268 54.2884 57.9268 49.8701V8.01001C57.9268 3.59173 54.345 0.0100098 49.9268 0.0100098Z",
    fill: "url(#paint0_linear_15_67)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9966 46.4299C38.6616 46.4299 46.4966 38.5949 46.4966 28.9299C46.4966 19.2649 38.6616 11.4299 28.9966 11.4299C19.3316 11.4299 11.4966 19.2649 11.4966 28.9299C11.4966 38.5949 19.3316 46.4299 28.9966 46.4299Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9966 33.6399C31.5978 33.6399 33.7065 31.5312 33.7065 28.9299C33.7065 26.3287 31.5978 24.22 28.9966 24.22C26.3953 24.22 24.2866 26.3287 24.2866 28.9299C24.2866 31.5312 26.3953 33.6399 28.9966 33.6399Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9967 29.8201C29.4882 29.8201 29.8867 29.4215 29.8867 28.9299C29.8867 28.4384 29.4882 28.04 28.9967 28.04C28.5052 28.04 28.1067 28.4384 28.1067 28.9299C28.1067 29.4215 28.5052 29.8201 28.9967 29.8201Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4067 28.9299C20.4094 26.6525 21.3152 24.4693 22.9256 22.8589C24.536 21.2485 26.7193 20.3427 28.9967 20.3401",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5966 28.9299C37.5966 31.2108 36.6905 33.3984 35.0777 35.0112C33.4649 36.624 31.2774 37.53 28.9966 37.53",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3066 28.9299C16.3066 25.5643 17.6437 22.3366 20.0235 19.9568C22.4033 17.577 25.631 16.24 28.9966 16.24",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6966 28.9299C41.6939 32.2974 40.3551 35.5261 37.9739 37.9072C35.5928 40.2884 32.364 41.6272 28.9966 41.6299",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15_67",
    x1: 2.41665,
    y1: 55.5201,
    x2: 55.5868,
    y2: 2.35001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FEC978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFB3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#55E1FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster);
export default __webpack_public_path__ + "static/media/master.34cb5cfee88c2beef81c90019e54c8bd.svg";
export { ForwardRef as ReactComponent };